var _path, _g, _path2, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvTech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ev_tech",
    "data-name": "ev tech",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.99,
    height: 70.775,
    viewBox: "0 0 78.99 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M19.807,140.541a1.383,1.383,0,0,0,1.384-1.384v-1.384h1.384a1.384,1.384,0,1,0,0-2.767H21.191v-1.384a1.384,1.384,0,1,0-2.767,0v1.384H17.04a1.384,1.384,0,1,0,0,2.767h1.384v1.384A1.383,1.383,0,0,0,19.807,140.541Z",
    transform: "translate(-12.691 -123.06)",
    fill: "#ff7b00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454",
    transform: "translate(11.267 2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M64.218,364.063a8.268,8.268,0,1,0,8.288,8.287A8.288,8.288,0,0,0,64.218,364.063Z",
    transform: "translate(-55.928 -318.231)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M279.584,372.35a8.29,8.29,0,1,0,8.29-8.287A8.263,8.263,0,0,0,279.584,372.35Z",
    transform: "translate(-240.945 -318.231)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M330.747,79.247a11.05,11.05,0,1,0,15.63,15.626c4.316-4.316,3.236-18.862,3.236-18.862S335.062,74.933,330.747,79.247Z",
    transform: "translate(-283.416 -71.74)",
    fill: "#f2d3cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M143.656,8.39a4.151,4.151,0,1,0,4.151-4.151A4.156,4.156,0,0,0,143.656,8.39Zm5.535,0a1.384,1.384,0,1,1-1.384-1.384A1.385,1.385,0,0,1,149.191,8.39Z",
    transform: "translate(-131.241 -4.239)",
    fill: "#c5c5ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M77.591,35.938c-1.528-.112-15.071-.975-19.629,3.575a12.094,12.094,0,0,0-3.585,8.625,12.416,12.416,0,0,0,.707,4.055H31.459A6.8,6.8,0,0,0,25.8,55.231L16.541,69.11a1.376,1.376,0,0,0-.174.407A23.152,23.152,0,0,0,0,91.612a6.825,6.825,0,0,0,6.8,6.817H9.113c1.564,2.72,4.878,5.43,8.563,5.43s7-2.711,8.563-5.431H47.177c1.566,2.72,4.877,5.43,8.563,5.43s7-2.71,8.561-5.43h2.313a6.887,6.887,0,0,0,6.85-6.839V75.3a6.845,6.845,0,0,0-6.85-6.79H62.572V59.659a12.419,12.419,0,0,0,4.059.708,12.186,12.186,0,0,0,8.644-3.574c4.557-4.551,3.69-18.073,3.577-19.6A1.362,1.362,0,0,0,77.591,35.938ZM20.22,68.511l7.849-11.771a4.082,4.082,0,0,1,3.392-1.828h6.6v13.6H20.22Zm-2.357,32.577a6.926,6.926,0,0,1-6.493-4.524A6.656,6.656,0,0,1,17.7,87.52,6.951,6.951,0,0,1,24.669,94.3c0,.759-.221,1.519-.221,2.26v0C23.087,99.272,20.729,101.088,17.863,101.088Zm37.875,0a6.814,6.814,0,1,1,6.4-4.524A6.8,6.8,0,0,1,55.738,101.088Zm15-25.788V91.589a4.163,4.163,0,0,1-4.127,4.119H65.158a6.072,6.072,0,0,0,.1-1.379,9.518,9.518,0,1,0-19.035.007,6.014,6.014,0,0,0,.1,1.373H27.094a6.072,6.072,0,0,0,.1-1.379,9.518,9.518,0,1,0-19.037.007,6.013,6.013,0,0,0,.1,1.373H6.8a4.1,4.1,0,0,1-4.076-4.094A20.418,20.418,0,0,1,23.112,71.234h43.5A4.118,4.118,0,0,1,70.741,75.3ZM59.848,59.013v9.5H40.787v-13.6H55.738a4.057,4.057,0,0,1,.754.091c.177.258.365.518.562.764l-2.94,2.939a1.361,1.361,0,0,0,1.925,1.926L58.98,57.7c.246.2.516.381.775.556A3.989,3.989,0,0,1,59.848,59.013Zm13.493-4.142a9.543,9.543,0,0,1-11.307,1.6,6.944,6.944,0,0,0-.628-1.212L63.1,53.553h7.593a1.36,1.36,0,1,0,0-2.72h-4.87l5.6-5.575a1.35,1.35,0,1,0-1.907-1.911l-5.58,5.6V44.082a1.362,1.362,0,0,0-2.723,0v7.581L59.5,53.353a6.812,6.812,0,0,0-1.216-.63,9.475,9.475,0,0,1,1.605-11.286c2.37-2.366,9.049-2.907,13.79-2.907.931,0,1.788.022,2.522.053C76.4,43.047,76.177,52.038,73.341,54.871Z",
    transform: "translate(0 -35.801)",
    fill: "#3335cf"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(1.681 29.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M315.51,115.848a.831.831,0,0,1-.59-.244l-1.884-1.884a.834.834,0,0,1,0-1.179l1.884-1.884a.834.834,0,0,1,1.18,0l1.884,1.884a.834.834,0,0,1,0,1.179L316.1,115.6A.831.831,0,0,1,315.51,115.848Zm-.7-2.718.7.7.7-.7-.7-.7Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#6583fe"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495",
    transform: "translate(70.472 65.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M45.133,323.084a.834.834,0,0,1-.59-.244l-1.884-1.884a.834.834,0,0,1,0-1.179l1.884-1.884a.834.834,0,0,1,1.18,0l1.884,1.884a.834.834,0,0,1,0,1.179l-1.884,1.884A.834.834,0,0,1,45.133,323.084Zm-.7-2.718.7.7.7-.7-.7-.7Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvTech);
export default __webpack_public_path__ + "static/media/evTech.55c9ada6bcb999cdad55b9dfd70f36b3.svg";
export { ForwardRef as ReactComponent };